import { DesktopSettings } from '@honestica/electron-bridge-typing';
import { ROOT_WATCHPATH, SENDING_WATCHPATH } from '@launcher/constants';
import { filterSettingsWriteableToFS } from '@launcher/helpers/desktop';
import { defaultDesktopSettings } from '@launcher/utils';
import electronService from '@services/electron/electron.service';
import { logger } from '@services/logger/logger.service';

export async function resetFileSettings() {
  try {
    logger.info('DESKTOP', 'Reset FS settings');
    const dirPath = await electronService.getPath('userData');
    await window.electron.ensureDir(dirPath);

    const homedir = await electronService.getHomedir();
    const watchPath = await electronService.joinPaths(homedir, ROOT_WATCHPATH, SENDING_WATCHPATH);

    const settings: DesktopSettings = {
      ...(filterSettingsWriteableToFS(defaultDesktopSettings) as DesktopSettings),
      watchPath,
    };

    await window.electron.writeLocalSettings(settings);

    return settings;
  } catch (error) {
    logger.error('DESKTOP', 'Could not reset file settings', { error });
  }

  return undefined;
}
